import { login as loginApi } from "../../service/AuthService";

//アクションタイプ定義
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const login = request => dispatch => {
  dispatch({ type: LOGIN_REQUEST });
  loginApi(request)
    .then(response => {
      dispatch({ type: LOGIN_SUCCESS, payload: response });

      if (response.roleId === 1) {
        window.location.href = "/AdminMenu";
      } else if (response.roleId === 2) {
        window.location.href = "/StaffMenu";
      } else if (response.roleId === 3) {
        window.location.href = "/StudentMenu";
      }

      return Promise.resolve();
    })
    .catch(error => {
      const message = error.response.data.message;
      var message_jp;
      var messagecode;
      if (message === "Account not found") {
        messagecode = "メッセージコード：00_01_001";
        message_jp = "メッセージ：存在しないメールアドレスです。";
      } else if (message === "Wrong password") {
        messagecode = "メッセージコード：00_01_002";
        message_jp = "メッセージ：メールアドレスまたはパスワードに誤りがあります。";
      } else if (message === "The date is not valid.") {
        messagecode = "メッセージコード：00_01_003";
        message_jp = "メッセージ：メールアドレスが有効ではありません。";
      }
      dispatch({ type: LOGIN_FAIL, payload: { message: message_jp, message_code: messagecode } });
      return Promise.reject();
    });
};

export const logout = () => {
  localStorage.removeItem("user");
  return { type: LOGOUT_SUCCESS };
};
